import { backendClient } from '@neptune/shared/core-apis-backend-domain';

export function updateLastViewedProject(projectId: string) {
  return backendClient.updateLastViewed({ projectId });
}
